"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5785],{

/***/ 80251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ logger; }
});

// EXTERNAL MODULE: ./src/providers/getEnv.ts
var getEnv = __webpack_require__(4266);
// EXTERNAL MODULE: ./node_modules/@sentry/types/esm/severity.js
var severity = __webpack_require__(13819);
;// CONCATENATED MODULE: ./src/helpers/logger/JustoError.ts
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent1, args1, Class1) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _wrapNativeSuper(Class2) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class2);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var JustoError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(JustoError, Error1);
    var _super = _createSuper(JustoError);
    function JustoError(errMessage, data) {
        var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "error";
        _classCallCheck(this, JustoError);
        var _this;
        _this = _super.call(this, errMessage);
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_assertThisInitialized(_this), JustoError);
        }
        _this.name = "JustoError";
        return _this;
    }
    return JustoError;
}(_wrapNativeSuper(Error));


;// CONCATENATED MODULE: ./src/helpers/logger/transports.ts


var logException = function(exception) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39666)).then(function(param) {
        var captureException = param.captureException;
        captureException(exception, {
            tags: {
                errorLevel: "JustoException"
            },
            level: severity/* Severity.Error */.z.Error,
            extra: data
        });
        console.error("Justo<exception>", exception, data);
    });
};
var logError = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39666)).then(function(param) {
        var captureException = param.captureException;
        captureException(new JustoError(message, data), {
            tags: {
                errorLevel: "JustoError"
            },
            level: severity/* Severity.Error */.z.Error,
            extra: data
        });
        console.error("Justo<error>", message, data);
    });
};
var logWarn = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39666)).then(function(param) {
        var captureMessage = param.captureMessage;
        captureMessage(new JustoError(message, data, "warning").message, {
            tags: {
                errorLevel: "JustoWarning"
            },
            level: severity/* Severity.Warning */.z.Warning,
            extra: data
        });
        console.warn("Justo<warn>", message, data);
    });
};
var logDebug = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    console.log("Justo<debug>", message, data);
    console.trace();
};
var logInfo = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    console.info("Justo<info>", message, data);
};
var log = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    console.info("Justo<log>", message, data);
    console.trace();
};
var envConfig = {
    local: {
        exception: logInfo,
        error: log,
        warn: log,
        info: logInfo,
        debug: logDebug
    },
    prod: {
        exception: logException,
        error: logError,
        warn: logWarn,
        info: logInfo,
        debug: logDebug
    },
    dev: {
        exception: logException,
        error: logError,
        warn: logWarn,
        info: logInfo,
        debug: logDebug
    }
};
/* harmony default export */ var transports = (envConfig);

;// CONCATENATED MODULE: ./src/helpers/logger/index.ts


/* harmony default export */ var logger = (transports[(0,getEnv/* default */.Z)()]);


/***/ }),

/***/ 25785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WithLogRocket": function() { return /* binding */ WithLogRocket; },
/* harmony export */   "default": function() { return /* binding */ useLogRocket; }
/* harmony export */ });
/* harmony import */ var _hooks_useCookiesAccepted__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35756);
/* harmony import */ var _hooks_useEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10338);
/* harmony import */ var _providers_getEnv__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4266);
/* harmony import */ var logrocket__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19258);
/* harmony import */ var logrocket__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(logrocket__WEBPACK_IMPORTED_MODULE_3__);




var random = function(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
var isSelected = function() {
    // Is a random that only would be true on 0,04% of all sessions
    return random(1, 250000) <= 100;
};
function useLogRocket() {
    var cookies = (0,_hooks_useCookiesAccepted__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    (0,_hooks_useEffect__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        if ((0,_providers_getEnv__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)() !== "prod" || !isSelected() || !cookies) return;
        logrocket__WEBPACK_IMPORTED_MODULE_3___default().init("1raysq/justo");
    }, [
        cookies
    ]);
};
var WithLogRocket = function(param) {
    var children = param.children;
    useLogRocket();
    return children;
};


/***/ }),

/***/ 2840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ doesCountryRequireCookies; }
/* harmony export */ });
function doesCountryRequireCookies(countryCode) {
    return countryCode === "PE";
};


/***/ }),

/***/ 35756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCookiesAccepted; }
/* harmony export */ });
/* harmony import */ var _helpers_websites_doesCountryRequireCookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2840);
/* harmony import */ var _hooks_useLocalStorageState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54501);
/* harmony import */ var _page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62832);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



function useCookiesAccepted() {
    var ref;
    var ref1 = _slicedToArray((0,_hooks_useLocalStorageState__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("prompCookies", null), 1), prompCookies = ref1[0];
    var initialData = (0,_page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    if ((0,_helpers_websites_doesCountryRequireCookies__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(initialData === null || initialData === void 0 ? void 0 : (ref = initialData.website) === null || ref === void 0 ? void 0 : ref.countryCode) === false) return true;
    if (!prompCookies) return false;
    return JSON.parse(prompCookies).userClickAccepted;
};


/***/ }),

/***/ 10338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useEffect; },
/* harmony export */   "d": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




/***/ }),

/***/ 54501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLocalStorageState; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80251);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90257);
/* harmony import */ var _providers_GlobalState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91733);




var getSavedValue = function getSavedValue(key, defaultValue) {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()) return defaultValue;
    if (!localStorage) return defaultValue;
    var savedValue = localStorage.getItem(key);
    if (savedValue === null) {
        return defaultValue;
    } else {
        try {
            return JSON.parse(savedValue);
        } catch (error) {
            _helpers_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(error);
            return defaultValue;
        }
    }
};
function useLocalStorageState(key, defaultValue) {
    var value = getSavedValue(key, defaultValue);
    var forceUpdate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_GlobalState__WEBPACK_IMPORTED_MODULE_2__/* .Context */ ._);
    var setValue = function(newValue) {
        localStorage.setItem(key, JSON.stringify(newValue));
        forceUpdate();
    };
    return [
        value,
        setValue
    ];
};


/***/ }),

/***/ 30562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));


/***/ }),

/***/ 62832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useInitialData; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _InitialDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30562);


function useInitialData() {
    var initialData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_InitialDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    return initialData;
};


/***/ })

}]);